import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        captchaToken: "",
        step: 0,
        products: [],
        productCategories: [],
        coupons: [],
        productsById: {},
        imageSelection: {images: [], persons: []},
        imageById: {},
        image: 0,
        basket: null,
        paymentInformation: null,
        newsletterAccepted: null,
        newsletterDialogOpen: false,
        stripe: undefined,
        codesInput: [],
    },
    getters: {
        captchaToken: state => state.captchaToken,
        step: state => String(state.step),
        products: state => state.products,
        productCategories: state => state.productCategories,
        coupons: state => state.coupons,
        imageSelection: state => state.imageSelection,
        product: (state) => (id) => state.productsById[String(id)],
        basketBadge: state => state.basket ? state.basket.positionCount : 0,
        basket: state => state.basket,
        paymentInformation: state => state.paymentInformation,
        imageById: state => id => state.imageById[id],
        newsletterAccepted: state => state.newsletterAccepted,
        newsletterDialogOpen: state => state.newsletterDialogOpen,
        persons: state => state.imageSelection.persons,
        stripe: state => state.stripe,
        codesInput: state => state.codesInput,
    },
    mutations: {
        setCaptchaToken(state, token) {
            state.captchaToken = token;
        },
        setStep(state, step) {
            state.step = step;
        },
        setImageSelection(state, imageSelection) {
            state.imageSelection = imageSelection;
            state.imageById = {};
            for (let i = 0; i<imageSelection.images.length; i++) {
                const image = imageSelection.images[i];
                state.imageById[image.uniqueId] = image;
            }
        },
        setImage(state, image) {
            state.image = image;
        },
        setProducts(state, products) {
            state.products = products.sort((a, b) => {
                return a.order - b.order;
            });
            state.productsById = {};
            for (let product of products) {
                Vue.set(state.productsById, product.id, product);
            }
        },
        setCoupons(state, coupons) {
            state.coupons = coupons;
        },
        setBasket(state, basket) {
            state.basket = basket;
        },
        setPaymentInformation(state, paymentInformation) {
            state.paymentInformation = paymentInformation;
        },
        setNewsletterAccepted(state, value) {
            state.newsletterAccepted = value;
        },
        setNewsletterDialogOpen(state, value) {
            state.newsletterDialogOpen = value;
        },
        setStripe(state, stripe) {
            state.stripe = stripe;
        },
        setCodesInput(state, codes) {
            state.codesInput = [...codes]
        },
        setProductCategories(state, categories) {
            state.productCategories = categories;
        }
    }
});
